var variables = {
  data () {
    return {
      // noCoverUrl: '/images/default/no-cover.png',
      noAvatarUrl: '/images/default/user-image.png',
      baseUrl: process.env.VUE_APP_BASE_URL,
      visibilityOptions: [
        {
          key: 'private',
          value: 'Privado',
          icon: 'lock'
        },
        {
          key: 'public',
          value: 'Público',
          icon: 'globe'
        }
      ],
      licenseOptions: [
        {
          key: 'cc0',
          value: 'CC0',
          icon: 'fab fa-creative-commons-zero',
          description: 'Escolhendo essa licença você concorda que seu conteúdo estará liberado para uso e derivação globalmente, sem restrição comercial nenhuma.'
        },
        {
          key: 'cc-by',
          value: 'CC-BY',
          icon: 'fab fa-creative-commons-by',
          description: 'Escolhendo essa licença você permite que copiem, distribuam, exibam, executem e derivem da sua obra, desde que os créditos sejam dados à você.'
        },
        {
          key: 'cc-by-sa',
          value: 'CC-BY-SA',
          icon: 'fab fa-creative-commons-sa',
          description: 'Escolhendo essa licença você permite que copiem, distribuam, exibam, executem e derivem da sua obra, desde que os créditos sejam dados à você e também que a obra resultante tenha a mesma licença desta obra.'
        },
        {
          key: 'cc-by-nc',
          value: 'CC-BY-NC',
          icon: 'fab fa-creative-commons-nc',
          description: 'Escolhendo essa licença você permite que copiem, distribuam, exibam, executem e derivem da sua obra, desde que os créditos sejam dados à você e também que a obra não seja usada para fins comerciais.'
        },
        {
          key: 'cc-by-nc-sa',
          value: 'CC-BY-NC-SA',
          icon: 'fab fa-creative-commons-sa',
          description: 'Escolhendo essa licença você permite que copiem, distribuam, exibam, executem e derivem da sua obra, desde que os créditos sejam dados à você, que a obra resultante tenha a mesma licença desta obra, e também que a obra não seja usada para fins comerciais.'
        },
        {
          key: 'cc-by-nd',
          value: 'CC-BY-ND',
          icon: 'fab fa-creative-commons-nd',
          description: 'Escolhendo essa licença você permite que copiem, distribuam, exibam, executem apenas a cópia exata da sua obra original, incluindo o uso para fins comerciais.'
        },
        {
          key: 'cc-by-nc-nd',
          value: 'CC-BY-NC-ND',
          icon: 'fab fa-creative-commons-nd',
          description: 'Escolhendo essa licença você proíbe que copiem, distribuam ou derivem da sua obra.'
        }
      ],
      categoryTooltipText: 'Categorias servem para você agrupar e organizar textos e livros de um mesmo assunto. Por exemplo: "Histórias de terror", "Resenhas" ou "Contos".',
      tagsTooltipText: 'Tags são palavras-chave que identificam os principais assuntos e temas tratados no texto ou livro. Por exemplo: "amor", "machado de assis" ou "suspense".',
      licenseTooltipText: 'São instrumentos de direitos que o autor pode exercer sobre sua obra para que ela seja manuseada e usada de forma que siga as suas regras pré-estabelecidas.',
      minimumBookAmount: 500,
      boletoFee: 335,
      minimumGroupAmount: 500
    }
  },
  computed: {
    noCoverUrl () {
      const array = [
        '/images/default/no-cover-1.jpg',
        '/images/default/no-cover-2.jpg',
        '/images/default/no-cover-3.jpg'
      ]

      return array[Math.floor(Math.random() * array.length)]
    }
  }
}

export default variables
